var render, staticRenderFns
import script from "./CustomFormDialog.vue?vue&type=script&lang=js&"
export * from "./CustomFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647d6262",
  null
  
)

export default component.exports